module.exports = __webpack_public_path__ + "_/resources/images/icn-agenda.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icn-agenda.svg
// module id = 1707
// module chunks = 0